var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container text-center mt-2"},[_c('div',{staticClass:"d-flex title-option"},[_c('h2',{staticClass:"h2-borde mt-3 mb-3 ms-5 text-main pt-1 px-4"},[_c('strong',[_vm._v("RESONANCIA")])])])])])
}]

export { render, staticRenderFns }